import { format, startOfDay } from 'date-fns'
import type { AxiosInstance } from 'axios'
import type { DailyStatsType, ProfileAvatarResponse, ProfileBodyType, ProfileType } from 'src/types/profile'


export class ProfileApi {
  api: AxiosInstance

  urls = {
    dailyStats: () => 'daily-stats/' as const,
    profile: () => 'profile/' as const,
    uploadAvatar: () => 'profile/upload-image/' as const,
  }

  constructor (api: AxiosInstance) {
    this.api = api
  }

  getDailyStats = async (date: Date): Promise<DailyStatsType> => {
    const params = { date: format(date, 'dd-MM-yyyy') }
    const response = await this.api.get<DailyStatsType>(
      this.urls.dailyStats(),
      { params }
    )
    return response.data
  }

  getProfile = async (): Promise<ProfileType> => {
    const response = await this.api.get<ProfileType>(
      this.urls.profile(),
      { params: { cache: String(Math.floor(Math.random() * 1_000_000_000)) } }
    )
    const profile = { ...response.data }
    profile.daily_calorie_by_days.map(dailyCalorie => {
      dailyCalorie.date = startOfDay(new Date(dailyCalorie.date))
    })
    return profile
  }

  patchProfile = async (userBody: ProfileBodyType): Promise<ProfileType> => {
    const response = await this.api.patch<ProfileType>(this.urls.profile(), userBody)
    return response.data
  }

  deleteProfile = async (): Promise<ProfileType> => {
    const response = await this.api.delete<ProfileType>(this.urls.profile(), { params: { confirm: 'true' }})
    return response.data
  }

  postAvatar = async (file: File): Promise<ProfileAvatarResponse> => {
    const form = new FormData()
    form.append('self_loaded_photo_url', file)
    const response = await this.api.patch<ProfileAvatarResponse>(
      this.urls.uploadAvatar(), form
    )
    return response.data
  }
}
